import getThemeProps from './getThemeProps';
import useTheme from '../useTheme';
export default function useThemeProps(_ref) {
  let {
    props,
    name,
    defaultTheme
  } = _ref;
  const theme = useTheme(defaultTheme);
  const mergedProps = getThemeProps({
    theme,
    name,
    props
  });
  return mergedProps;
}